import type { InsuranceReportRequestMetaDataType } from '@frontend/api-insurance-eligibility-report';
import { createShallowStore, createStore } from '@frontend/store';
import { DefaultInsuranceDetailsValues } from '../utils/constants';
import { InsuranceDetails } from '../utils/types';

export type VerifiedInsuranceDetailsByPersonIDType = InsuranceDetails & { personId: string };

type VerifiedInsuranceDetailsType = {
  verifiedInsuranceDetails: VerifiedInsuranceDetailsByPersonIDType;
  insuranceRequestDetails?: InsuranceReportRequestMetaDataType;
  setVerifiedInsuranceDetails: (details: VerifiedInsuranceDetailsByPersonIDType) => void;
  setInsuranceRequestDetails: (details: InsuranceReportRequestMetaDataType) => void;
  refetchInsuranceDetails?: () => void;
  setRefetchInsuranceDetails: (refetchInsuranceDetails: () => void) => void;
};

export const useGetVerifiedInsuranceDetailsStore = createStore<VerifiedInsuranceDetailsType>(
  (set) => ({
    verifiedInsuranceDetails: { ...DefaultInsuranceDetailsValues, personId: '' },
    setVerifiedInsuranceDetails: (details) => set({ verifiedInsuranceDetails: details }),
    setInsuranceRequestDetails: (details) => set({ insuranceRequestDetails: details }),
    setRefetchInsuranceDetails: (refetchInsuranceDetails) => set({ refetchInsuranceDetails }),
  }),
  {
    name: 'verified-insurance-details-store',
  }
);

export const useGetVerifiedInsuranceDetailsShallowStore = createShallowStore<VerifiedInsuranceDetailsType>(
  useGetVerifiedInsuranceDetailsStore
);
